/**
 * V2 dashboard period model — today / week / month only, resolved server-side
 * in the entity's reporting timezone (GET /{scope}/dashboard/{tab}?period=...).
 * Custom ranges and client tz params were dropped with dashboard v2.
 */
export const PERIOD_LABEL = {
    today: 'Today',
    week: 'This week',
    month: 'This month',
};
export const DASHBOARD_PERIODS = [
    { value: 'today', label: PERIOD_LABEL.today },
    { value: 'week', label: PERIOD_LABEL.week },
    { value: 'month', label: PERIOD_LABEL.month },
];
const VALID_PERIODS = new Set(DASHBOARD_PERIODS.map((p) => p.value));
/** Parse an untrusted period value (URL param); falls back to 'today'. */
export function parseDashboardPeriod(raw) {
    return VALID_PERIODS.has(raw || '') ? raw : 'today';
}
